import React from 'react';
import { createPortal } from 'react-dom';

interface ModalPortalProps {
  children: React.ReactNode;
}

/** Renderiza modais em document.body para não serem cortados por transform/overflow dos pais. */
const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  if (typeof document === 'undefined') {
    return null;
  }
  return createPortal(children, document.body);
};

export default ModalPortal;
